/** Tag vocabulary (idea.md §8.1) — small, non-clinical wording. */
export const SEGMENT_TAGS = [
    { kind: "correct", label: "Correct", shortcut: "1", glyph: "✓", color: "#4ade80", hint: "Produced as targeted." },
    { kind: "approximate", label: "Approximate", shortcut: "2", glyph: "~", color: "#22d3ee", hint: "Recognizable, not clean." },
    { kind: "substituted", label: "Substituted", shortcut: "3", glyph: "✗→", color: "#fbbf24", hint: "A different sound was produced." },
    { kind: "distorted", label: "Distorted", shortcut: "4", glyph: "≈", color: "#fb923c", hint: "Right place, wrong quality." },
    { kind: "omitted", label: "Omitted", shortcut: "5", glyph: "–", color: "#f87171", hint: "Not produced." },
    { kind: "added", label: "Added", shortcut: "6", glyph: "+", color: "#a78bfa", hint: "An extra sound was inserted." },
    { kind: "unclear", label: "Unclear", shortcut: "0", glyph: "?", color: "#8891b5", hint: "Can't tell from the recording." },
];
const BY_KIND = new Map(SEGMENT_TAGS.map((t) => [t.kind, t]));
const BY_KEY = new Map(SEGMENT_TAGS.map((t) => [t.shortcut, t]));
export function tagForShortcut(key) {
    return BY_KEY.get(key) ?? null;
}
export function tagDef(kind) {
    return BY_KIND.get(kind);
}
export function tagGlyph(tag) {
    if (!tag)
        return "·";
    const def = tagDef(tag.kind);
    return tag.kind === "substituted" && tag.to ? `✗→${tag.to}` : def.glyph;
}
export function tagColor(tag) {
    return tag ? tagDef(tag.kind).color : "#8891b5";
}
/** Tags that mean "the target did not come out" — used by the rail filter. */
export const TARGET_FAIL_KINDS = [
    "substituted",
    "distorted",
    "omitted",
];
